import PropTypes from 'prop-types';

var propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    images: PropTypes.arrayOf(PropTypes.string),
    noImagesText: PropTypes.string,
};
var defaultProps = {
    images: [],
    noImagesText: 'Add',
};

export { defaultProps, propTypes };
